var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41671 1.83337H15.5834C16.5959 1.83337 17.4167 2.65419 17.4167 3.66671V18.3334C17.4167 19.3459 16.5959 20.1667 15.5834 20.1667H6.41671C5.40419 20.1667 4.58337 19.3459 4.58337 18.3334V3.66671C4.58337 2.65419 5.40419 1.83337 6.41671 1.83337ZM6.41671 3.66671V18.3334H15.5834V3.66671H6.41671ZM11.9167 16.5C11.9167 17.0063 11.5063 17.4167 11 17.4167C10.4938 17.4167 10.0834 17.0063 10.0834 16.5C10.0834 15.9938 10.4938 15.5834 11 15.5834C11.5063 15.5834 11.9167 15.9938 11.9167 16.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.21b863fd9f6b38922ce66f724688b2a7.svg";
export { ForwardRef as ReactComponent };